<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-button :variant="variantDefult" :disabled="disable || loader" @click="accion()" :pill="pill">
      <span v-if="!loader">{{ botonTextDefult }}</span>
      <span v-if="loader">
                        <b-spinner small></b-spinner>
                    {{ loadingTextDefult }}
                    </span>
    </b-button>
  </div>

</template>

<script>
export default {
  name: "BotonCancelar",
  props: {
    botonText: String,
    variant: String,
    loader: Boolean,
    loadingText: String,
    historyBack: Boolean,
    disable: Boolean,
    pill: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      botonTextDefult: "Cancelar",
      loadingTextDefult: "Cargando...",
      variantDefult: "secondary",
      disableDefult: false
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.botonText !== undefined && this.botonText !== null) {
      this.botonTextDefult = this.botonText
    }

    if (this.loadingText !== undefined && this.loadingText !== null) {
      this.loadingTextDefult = this.loadingText
    }

    if (this.variant !== undefined && this.variant !== null) {
      this.variantDefult = this.variant
    }

  },
  methods: {
    accion() {
      if (this.historyBack) {
        window.history.back()
      }
      this.$emit("accion")
    }
  }
}
</script>

<style scoped>

</style>
